<template>
<el-container>
 <el-main>
     <!-- 绑定网关 -->
     <el-dialog
      :title="$t('deviceList.bindGateway')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addGatewayVisible"
      width="760px"
    >
      <el-form :inline="true" :model="gatewayForm" ref="gatewayForm" class="demo-ruleForm">
        <el-form-item label-width="120px" :label="$t('deviceList.apartment')">
        <el-select v-model="gatewayForm.apartmentItem" filterable :placeholder="$t('deviceList.chooseApartment')" @change="gatewayApartmentSelectChange" style="width:220px">
         <el-option
          v-for="item in gatewayForm.apartmentData"
          :key="setVal(item)"
          :label="item.apartmentName"
          :value="setVal(item)">
         </el-option>
        </el-select>
      </el-form-item> 

      <el-form-item label-width="120px" :label="$t('deviceList.floor')">
        <el-select v-model="gatewayForm.floorId" filterable :placeholder="$t('deviceList.chooseFloor')" @change="gatewayFloorSelectChange" style="width:220px">
         <el-option
          v-for="item in gatewayForm.floorData"
          :key="item.floorId"
          :label="item.floorName"
          :value="item.floorId">
         </el-option>
        </el-select>
      </el-form-item> 

      <el-form-item label-width="120px" :label="$t('deviceList.room')">
        <el-select @keyup.native="selectKeyupGateway($event)" @click.native="gatewayRoomClick" v-model="gatewayForm.roomId" filterable :placeholder="$t('deviceList.chooseRoom')" style="width:220px">
         <el-option
          v-for="item in gatewayForm.roomData"
          :key="item.roomId"
          :label="item.roomName"
          :value="item.roomId">
         </el-option>
        </el-select>
      </el-form-item>  

      <el-form-item
          :label="$t('deviceList.gatewayId')"
          label-width="120px"
          prop="addGatewayNum"
          :rules="[{ required: true, message: $t('commomArea.number-input')}]"
        >
          <el-input
            v-model="gatewayForm.addGatewayNum"
            :placeholder="$t('deviceList.inputGatewayId')"
            maxlength="20"
            show-word-limit
            style="width:220px"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('commomArea.gatewayName')"
          label-width="120px"
          prop="addGatewayName"
          :rules="[{required: true, message: $t('commomArea.gatewayName-input')}]"
        >
          <el-input
            v-model="gatewayForm.addGatewayName"
            :placeholder="$t('commomArea.gatewayName')"
            maxlength="30"
            show-word-limit
            style="width:220px"
          ></el-input>
        </el-form-item>
        
        <el-form-item style="display:flex;justify-content:center;align-items:center;">
          <el-button type="primary" @click="addGateway()">{{$t('commomArea.confirm')}}</el-button>
          <el-button type="primary" @click="addGatewayVisible=false">{{$t('commomArea.cancel')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 绑定门锁设备 -->
    <el-dialog
      :title="$t('deviceList.bindLock')"
      :modal-append-to-body="true"
      :lock-scroll="true"
      :visible.sync="bindDeviceVisible"
      width="800px"
      style=""
    > 
      <el-form
      :inline="true"
      :model="bindDeviceForm"
      ref="bindDeviceForm"
      class="demo-ruleForm"
      >
      <el-form-item label-width="100px" :label="$t('deviceList.apartment')">
        <el-select v-model="bindDeviceForm.apartmentItem" filterable :placeholder="$t('deviceList.chooseApartment')" @change="deviceApartmentSelectChange" style="width:250px">
         <el-option
          v-for="item in bindDeviceForm.apartmentData"
          :key="setVal(item)"
          :label="item.apartmentName"
          :value="setVal(item)">
         </el-option>
        </el-select>
      </el-form-item>  
      <el-form-item label-width="100px" :label="$t('deviceList.floor')">
        <el-select v-model="bindDeviceForm.floorId" filterable :placeholder="$t('deviceList.chooseFloor')" @change="deviceFloorSelectChange" style="width:250px">
         <el-option
          v-for="item in bindDeviceForm.floorData"
          :key="item.floorId"
          :label="item.floorName"
          :value="item.floorId">
         </el-option>
        </el-select>
      </el-form-item> 
      <el-form-item label-width="100px" :label="$t('deviceList.room')">
        <el-select @keyup.native="selectKeyupDevice($event)" @click.native="deviceRoomClick" v-model="bindDeviceForm.roomId" filterable :placeholder="$t('deviceList.chooseRoom')" @change="deviceRoomSelectChange" style="width:250px">
         <el-option
          v-for="item in bindDeviceForm.roomData"
          :key="item.roomId"
          :label="item.roomName"
          :value="item.roomId">
         </el-option>
        </el-select>
      </el-form-item>  
       <el-form-item label-width="100px" :label="$t('deviceList.deviceType')">
        <el-select v-model="bindDeviceForm.deviceType" :placeholder="$t('deviceList.chooseDeviceTpe')" style="width:250px">
         <el-option
          v-for="item in bindDeviceForm.deviceTypeData"
          :key="item.value"
          :label="item.label"
          :value="item.value">
         </el-option>
        </el-select>
      </el-form-item>  
      <el-form-item label-width="100px" :label="$t('deviceList.gateway')" v-show="bindDeviceForm.deviceType==1">
        <el-select v-model="bindDeviceForm.gatewayId" :placeholder="$t('deviceList.chooseGateway')" style="width:250px">
         <el-option
          v-for="item in bindDeviceForm.gatewayData"
          :key="item.deviceId"
          :label="item.deviceName"
          :value="item.deviceId">
         </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="100px" :label="$t('deviceList.deviceId')"  v-show="bindDeviceForm.deviceType!=2">
         <el-input v-model="bindDeviceForm.lockId" :placeholder="$t('deviceList.chooseDeviceId')" style="width:250px"></el-input>
      </el-form-item>
       <el-form-item label-width="100px" :label="$t('deviceList.lockNum')" v-show="bindDeviceForm.deviceType==2">
         <el-input v-model="bindDeviceForm.lockNum" :placeholder="$t('deviceList.inputLockNum')" style="width:250px"></el-input>
      </el-form-item>
      <el-form-item label-width="100px" :label="$t('deviceList.deviceName')">
         <el-input v-model="bindDeviceForm.lockName" :placeholder="$t('deviceList.inputDeviceName')" style="width:250px"></el-input>
      </el-form-item>
      
      <div style="margin-top: 10px">
       <el-button type="primary" @click="bindDeviceRoom">{{$t("apartmentRoomDetail.confirm")}}</el-button>
       <el-button type="primary" @click="bindDeviceVisible = false;">{{ $t("apartmentRoomDetail.cancel") }}</el-button>
       <!-- <el-button style="float:right" @click="bindDeviceRoom">测试绑定</el-button> -->
     </div>
    </el-form>
     
    </el-dialog>
    <!-- 选择公寓 -->
    <el-dialog
      :title="$t('tenant.chooseApartment')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="apartmentListVisible"
      width="550px"
      style="margin-top:-30px"
    > 
      <el-form :inline="true" class="demo-form-inline" style="margin-top:-20px">
      <el-form-item :label="$t('tenant.apartmentName')">
         <el-input v-model="selectApartmentForm.apartmentName" clearable placeholder=""></el-input>
      </el-form-item>
      <el-form-item >
        <el-button type="primary" @click="onSelectApartment">{{$t('tenant.qurey')}}</el-button>
      </el-form-item>
      </el-form>
      <el-table
        ref="singleTable"
        :data="apartmentList"
        highlight-current-row
        @current-change="handleCurrentChangeDetail"
        height=280px
        style="margin-top:-10px"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column
          property="apartmentName"
          :label="$t('tenant.apartmentName')"
          width="120"
        ></el-table-column>
        <el-table-column
          property="apartmentType"
          :label="$t('tenant.apartmentType')"
          :formatter="this.$util.apartmentTypeFormat"
          width="80"
        >
        </el-table-column>
      
        <el-table-column prop="" :label="$t('tenant.area')" align="center" width="200px">
         <template slot-scope="scope">
           {{scope.row.province}} - {{scope.row.city}} - {{scope.row.area}}
         </template> 
        </el-table-column>
        <el-table-column
          property="apartmentAddress"
          :label="$t('tenant.address')"
          width="120"
        ></el-table-column>
      </el-table>

      <div style="margin-top: 10px">
        <Pagings
          :total="apartmentTotal"
          :offset="apartmentPageData.offset"
          :pageSize="apartmentPageData.pageNumber"
          @handleSizeChangeSub="apartmentHandleSizeChange"
          @handleCurrentChangeSub="apartmentHandleCurrentChange"
        ></Pagings>
      </div>
      <div style="margin-top: 10px">
        <el-button type="primary" @click="confirmChooseApartment">{{$t('tenant.confirmChoose')}}</el-button>
        <el-button type="primary" @click="checkInVisible = true;apartmentListVisible = false;">{{$t('tenant.cancel')}}</el-button>
      </div>
    </el-dialog>
    <!-- 绑定发卡机 -->
    <el-dialog
      :title="$t('deviceList.bindColletor')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addDeviceFlag"
      width="500px"
    >
      <el-form
        :inline="true"
        :model="addDevice"
        ref="addDevice"
        class="demo-ruleForm"
      >
      <!-- <el-form-item
          label="公寓"
          label-width="120px"
        >
          <el-input
            type="text"
            disabled
            v-model="addDevice.apartmentName"
            placeholder="请选择绑定公寓"
            style="width: 200px"
            maxlength="30"
            show-word-limit
          ></el-input>
           <el-button size="medium" :title="$t('tenant.chooseApartment')" icon="el-icon-office-building" type="primary" @click="chooseApartment"></el-button>
      </el-form-item> -->

      <el-form-item
          :label="$t('deviceList.deviceId')"
          label-width="120px"
        >
          <el-input
            type="text"
            v-model="addDevice.deviceId"
            :placeholder="$t('deviceList.chooseDeviceId')"
            style="width: 200px"
            maxlength="30"
            show-word-limit
          ></el-input>
      </el-form-item>

      <el-form-item
          :label="$t('deviceList.deviceName')"
          label-width="120px"
        >
          <el-input
            type="text"
            v-model="addDevice.deviceName"
            :placeholder="$t('deviceList.deviceName')"
            style="width: 200px"
            maxlength="30"
            show-word-limit
          ></el-input>
      </el-form-item>
       <el-form-item
          style="display: flex; justify-content: center; align-items: center"
        >
          <el-button type="primary" @click="addFgDevice()">{{
            $t("apartmentRoomDetail.confirm")
          }}</el-button>
          <el-button type="primary" @click="addDeviceFlag = false">{{
            $t("apartmentRoomDetail.cancel")
          }}</el-button>
      </el-form-item>
    </el-form>  
    </el-dialog>
    
   <el-tabs type="border-card" v-model="activeName">
    <el-tab-pane :label="$t('deviceList.gateway')" name="gatewayList">
       <el-form
        :inline="true"
        :model="gatewayListForm"
        ref="gatewayListForm"
        class="demo-ruleForm"
      >
       <el-form-item :label="$t('deviceList.apartmentName')">
          <el-input v-model="gatewayListForm.apartmentName" style="width:150px" :placeholder="$t('deviceList.inputApartmentName')"></el-input>
       </el-form-item>  
       <el-form-item :label="$t('deviceList.gatewayId')">
          <el-input v-model="gatewayListForm.deviceId" style="width:150px" :placeholder="$t('deviceList.inputGatewayId')"></el-input>
          <el-button @click="gatewaySelect" type="primary" icon="el-icon-search">{{$t('deviceList.qurey')}}</el-button>
           <el-button type="primary" plain icon="el-icon-cpu" @click="onBindGateway">{{$t('deviceList.bindGateway')}}</el-button>
         </el-form-item>
      </el-form>
      
        <el-table
          :data="gatewayPageData.gatewayData"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          empty-text="No Data"
          border
          style="margin-top: 5px"
        >
         <el-table-column
           prop="apartmentName"
           :label="$t('deviceList.apartmentName')">
         </el-table-column>
         <el-table-column
           prop="floorName"
           :label="$t('deviceList.floorName')">
         </el-table-column>
         <el-table-column
           prop="roomName"
           :label="$t('deviceList.roomName')">
         </el-table-column>
        <el-table-column
         <el-table-column
           prop="deviceId"
           :label="$t('deviceList.gatewayId')">
        </el-table-column>
        <el-table-column
         <el-table-column
           prop="deviceName"
           :label="$t('deviceList.gatewayName')">
         </el-table-column>

         <!-- <el-table-column
          prop="deviceType"
          label="设备类型">
           <template slot-scope="scope">
             {{scope.row.deviceType==0?"网关":scope.row.deviceType==1?"带网关联网锁":scope.row.deviceType==2?"离线门锁":scope.row.deviceType==3?"运营商平台NB联网锁":scope.row.deviceType==4?"蓝牙门锁":scope.row.deviceType==5?"4G/NB直连锁":scope.row.deviceType==6?"WiFi直连锁":scope.row.deviceType}}
           </template>  
         </el-table-column> -->

        <el-table-column
          prop="isOnline"
          :label="$t('deviceList.onlineStatus')">
          <template slot-scope="scope">
             {{scope.row.isOnline==0?$t('deviceList.offline'):scope.row.isOnline==1?$t('deviceList.online'):""}}
          </template>  
        </el-table-column>

        <el-table-column
          prop="isOnline"
          :label="$t('deviceList.oparete')">
         <template slot-scope="scope"> 
         <el-button
          type="danger"
          size="mini"
          @click="gatewayUnbind(scope.$index, scope.row)"
         >{{$t('deviceList.unbind')}}</el-button>
        </template>
        </el-table-column>  

        </el-table>
        <el-footer>
        <div>
         <Pagings
          :total="gatewayPageData.total"
          :offset="gatewayPageData.offset"
          :pageSize="gatewayPageData.pageNumber"
          @handleSizeChangeSub="gHandleSizeChange"
          @handleCurrentChangeSub="gHandleCurrentChange"
          ></Pagings>
         </div>
        </el-footer>   
    </el-tab-pane>
    <el-tab-pane :label="$t('deviceList.fingerprintCollector')" name="fpDeviceList">
        <div>
          <el-button type="primary" plain icon="el-icon-cpu" @click="onBindFgDevice">{{$t('deviceList.bindColletor')}}</el-button>
        </div>
         <el-table
          :data="fgPageData.fgData"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          empty-text="No Data"
          border
          style="margin-top: 5px"
        >
        <el-table-column
           prop="deviceId"
           :label="$t('deviceList.deviceId')"
          >
         </el-table-column>

         <el-table-column
           prop="deviceName"
           :label="$t('deviceList.deviceName')"
          >
         </el-table-column>

         <!-- <el-table-column
          prop="deviceType"
          label="设备类型">
           <template slot-scope="scope">
             {{scope.row.deviceType==0?"网关":scope.row.deviceType==1?"带网关联网锁":scope.row.deviceType==2?"离线门锁":scope.row.deviceType==3?"运营商平台NB联网锁":scope.row.deviceType==4?"蓝牙门锁":scope.row.deviceType==5?"4G/NB直连锁":scope.row.deviceType==6?"WiFi直连锁":scope.row.deviceType==12?"指纹采集器":scope.row.deviceType}}
           </template>
         </el-table-column> -->

        <el-table-column
          prop="isOnline"
         
          :label="$t('deviceList.onlineStatus')">
          <template slot-scope="scope">
             {{scope.row.online==0?$t('deviceList.offline'):scope.row.online==1?$t('deviceList.online'):""}}
          </template>
        </el-table-column>

         <el-table-column
           prop="bindTime"
           :label="$t('deviceList.bindTime')"
           :formatter="this.$util.datetimeFormat"
          >
         </el-table-column>

        <el-table-column
          prop
          :label="$t('apartmentRoomDetail.operate')"
          width="100"
          align="center"
        >
        <template slot-scope="scope">
        <el-button
          type="danger"
          size="mini"
          @click="handleUnbind(scope.$index, scope.row)"
         >{{$t('deviceList.unbind')}}</el-button>
        </template>
       </el-table-column>
        </el-table>
        <el-footer>
        <div>
         <Pagings
          :total="fgPageData.total"
          :offset="fgPageData.offset"
          :pageSize="fgPageData.pageNumber"
          @handleSizeChangeSub="fHandleSizeChange"
          @handleCurrentChangeSub="fHandleCurrentChange"
          ></Pagings>
         </div>
        </el-footer>   
    </el-tab-pane>
    <el-tab-pane :label="$t('deviceList.lockDevice')" name="lockList">
      <div>
      <el-form
        :inline="true"
        :model="deviceListForm"
        ref="deviceListForm"
        class="demo-ruleForm"
      >
       <el-form-item :label="$t('deviceList.apartmentName')">
          <el-input v-model="deviceListForm.apartmentName" style="width:140px" :placeholder="$t('deviceList.inputApartmentName')"></el-input>
       </el-form-item>  
       <el-form-item :label="$t('deviceList.onlineStatus')">
        <el-select v-model="deviceListForm.online" style='width:120px' :placeholder="$t('roomList.choose')">
          <el-option
           v-for="item in deviceListForm.onlineData"
           :key="item.value"
           :label="item.label"
           :value="item.value">
          </el-option>
        </el-select>
       </el-form-item>  
       <el-form-item :label="$t('deviceList.power')">
          <el-select v-model="deviceListForm.batteryLow" style='width:120px' :placeholder="$t('roomList.choose')">
          <el-option
           v-for="item in deviceListForm.batteryLowData"
           :key="item.value"
           :label="item.label"
           :value="item.value">
          </el-option>
        </el-select>
       </el-form-item> 
       <el-form-item :label="$t('deviceList.deviceId')">
          <el-input v-model="deviceListForm.deviceId" style="width:140px" :placeholder="$t('deviceList.chooseDeviceId')"></el-input>
        </el-form-item>
         <el-form-item>
          <el-button @click="deviceSelect" type="primary" icon="el-icon-search">{{$t('deviceList.qurey')}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-refresh" @click="refresh">{{$t('deviceDetail.refresh')}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain icon="el-icon-cpu" @click="bindDevice">{{$t('deviceList.bindLock')}}</el-button>
        </el-form-item>
      </el-form>
        
      </div>
         <el-table
          :data="lockPageData.lockData"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          empty-text="No Data"
          border
        >
         <el-table-column
           prop="apartmentName"
           :label="$t('deviceList.apartmentName')">
         </el-table-column>
         <el-table-column
           prop="floorName"
           :label="$t('deviceList.floorName')">
         </el-table-column>
         <el-table-column
           prop="roomName"
           :label="$t('deviceList.roomName')">
         </el-table-column>
        <el-table-column
          prop="deviceType"
          :label="$t('deviceList.deviceType')">
           <template slot-scope="scope">
             {{scope.row.deviceType==0?$t('deviceList.gateway'):scope.row.deviceType==1?$t('deviceList.gatewayLock'):scope.row.deviceType==2?$t('deviceList.offlineLock'):scope.row.deviceType==3?$t('deviceList.nbNetLock'):scope.row.deviceType==4?$t('deviceList.bleLock'):scope.row.deviceType==5?$t('deviceList.4gLock'):scope.row.deviceType==6?$t('deviceList.wifiLock'):scope.row.deviceType}}
           </template>  
         </el-table-column>
         <el-table-column
           prop="deviceId"
           :label="$t('deviceList.deviceId')">
         </el-table-column>
        <el-table-column
           prop="battery"
           width="80"
           :label="$t('deviceList.power')">
           <template slot-scope="scope">
             {{scope.row.battery}}%
           </template>  
         </el-table-column>
        
         <el-table-column
          prop="isOnline"
          width="80"
          :label="$t('deviceList.onlineStatus')">
          <template slot-scope="scope">
             {{scope.row.isOnline==0?$t('deviceList.offline'):scope.row.isOnline==1?$t('deviceList.online'):""}}
          </template>
        </el-table-column>
        <el-table-column
          prop
          :label="$t('deviceList.oparete')"
          width="220"
          align="center"
        >
        <template slot-scope="scope">
          <el-button
          type="primary"
          size="mini"
          @click="deviceAuth(scope.$index, scope.row)"
          >{{$t('deviceList.details')}}</el-button>
         <el-button
          type="primary"
          size="mini"
          @click="openLock(scope.$index, scope.row)"
          v-show="scope.row.deviceType!=2&&scope.row.deviceType!=4"
          >{{$t('deviceList.openLock')}}</el-button>
         <el-button
          type="danger"
          size="mini"
          @click="deviceUnbind(scope.$index, scope.row)"
         >{{$t('deviceList.unbind')}}</el-button>
        </template>
       </el-table-column>
        </el-table>
        <el-footer>
        <div>
         <Pagings
          :total="lockPageData.total"
          :offset="lockPageData.offset"
          :pageSize="lockPageData.pageNumber"
          @handleSizeChangeSub="lHandleSizeChange"
          @handleCurrentChangeSub="lHandleCurrentChange"
          ></Pagings>
         </div>
        </el-footer>   
    </el-tab-pane>
    </el-tabs>
 </el-main>
</el-container>   
</template>

<script>
import Pagings from "../common/Pagings.vue";
export default {
   name: "deviceList", //这个LoginName最好和引入的vue的LoginName相同
   data() {
      return {
         gatewayListForm:{
           deviceId:"",
           apartmentName:""
         },
         deviceListForm:{
           deviceId:"",
           apartmentName:"",
           online:this.$route.query.isOnline==undefined?'':parseInt(this.$route.query.isOnline),
           onlineData:[
             {label:this.$t('tenant.all'),value:''},
             {label:this.$t('deviceList.offline'),value:0},
             {label:this.$t('deviceList.online'),value:1}
           ],
           batteryLow:this.$route.query.batteryLow==undefined?0:parseInt(this.$route.query.batteryLow),
           batteryLowData:[
              {label:this.$t('deviceList.normal'),value:0},
              {label:this.$t('deviceList.lowBattery'),value:1}
           ]
         },
         checkInVisible:false,
         bindDeviceForm:{
          apartmentId:"",
          floorId:"",
          roomId:"",
          lockName:"",
          lockId:"",
          deviceType:1,
          deviceTypeData:[
            {value:1,label:this.$t('deviceList.gatewayLock')},
            {value:2,label:this.$t('deviceList.offlineLock')},
            {value:3,label:this.$t('deviceList.nbNetLock')},
            {value:5,label:this.$t('deviceList.4gLock')},
            {value:6,label:this.$t('deviceList.wifiLock')}
          ],
          apartmentData:"",
          buildingData:[],
          floorData:"",
          roomData:"",
          apartmentItem:"",
          apartmentId:"",
          buildingId:"",
          floorId:"",
          roomId:"",
          gatewayData:[],
          gatewayId:"",
          lockNum:""
        },
        bindDeviceVisible:false,
        currentApartmentRow:"",
        apartmentTotal: 1, //总条数
        apartmentPageData: {
         offset: 1,
         pageNumber: 10
        },
        apartmentList: [],
        apartmentListVisible:false,
        selectApartmentForm:{
          apartmetnName:""
        },
        addDeviceFlag:false,
        addDevice:{
           apartmentId:"",
           apartmentName:"",
           deviceId:"",
           adviceName:""
        },
        activeName:this.$route.query.activeName==undefined?"gatewayList":"lockList",
        gatewayPageData: {
         offset: 1,
         pageNumber: 10,
         total: 0, //总条数
         gatewayData: [],
        },
        fgPageData:{
         offset: 1,
         pageNumber: 10,
         total: 0, //总条数
         fgData: [],
        },
        lockPageData:{
         offset: 1,
         pageNumber: 10,
         total: 0, //总条数
         lockData: [],
        },
        gatewayForm: {
         addGatewayName: "",
         addGatewayNum: "",
         apartmentData:"",
         buildingData:[],
         floorData:"",
         roomData:"",
         apartmentItem:"",
         apartmentId:"",
         buildingId:"",
         floorId:"",
         roomId:"",
         roomName:""
        },
        addGatewayVisible:false
      }
    },
    components: {
      Pagings
    },
    mounted() {
      this.getGatewayPageList();
      this.getFgPageList();
      this.getLockPageList();
      this. apartmentPower();
      // this.getApartmentPageList();
    },    
    methods: {
      //网关房间点击事件
      gatewayRoomClick(){
          if(this.gatewayForm.roomId==""||this.gatewayForm.roomId==null){
            this.getRoomPageList(this.gatewayForm.apartmentId,this.gatewayForm.floorId,0,"");
          }
      },
      //设备房间点击事件
      deviceRoomClick(){
          if(this.bindDeviceForm.roomId==""||this.bindDeviceForm.roomId==null){
            this.getRoomPageList(this.bindDeviceForm.apartmentId,this.bindDeviceForm.floorId,1,"");
          }
      },
      //设备绑定房间按下事件
      selectKeyupDevice(e){
         var keynum = window.event ? e.keyCode :e.which; //获取键盘吗
        console.log("keynum",keynum)
        var roomName=e.target.value+"";
        this.getRoomPageList(this.bindDeviceForm.apartmentId,this.bindDeviceForm.floorId,1,roomName);
      },
      //网关绑定房间按下事件
      selectKeyupGateway(e){
        var keynum = window.event ? e.keyCode :e.which; //获取键盘吗
        console.log("keynum",keynum)
        var roomName=e.target.value+"";
        this.getRoomPageList(this.gatewayForm.apartmentId,this.gatewayForm.floorId,0,roomName);
      },
      //刷新
      refresh(){
       this.getLockPageList(); 
      },
      //门锁授权
      deviceAuth(index,row){
         this.$router.push({path: "/deviceAuth",query: {deviceId:row.deviceId,roomId:row.roomId,apartmentId:row.apartmentId}});
      },
      gatewaySelect(){
        this.getGatewayPageList();
      },
      deviceSelect(){
        this.getLockPageList();
      },
      openLock(index,row){
       var formData = new FormData();
       formData.append("deviceId", row.deviceId);
       formData.append("operationType", 1); //设备类型：应用网关0，联网门锁1，离线门锁2，NB门锁3
       this.$server
        .exam("/customer/lock/deviceRemoteOperation", formData)
        .then(data => {
          if (data.code == 200) {
            var rtnData = data["data"];
            const loading = this.$loading({
              lock: true,
              text: this.$t('deviceDetail.openLock'),
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            var obj = {};
            obj.rId = rtnData;
            obj.loading = loading;
            obj.opType = "openLock";
            this.$store.dispatch("checkResult", obj); //等待回调
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
      },
      setVal(item){
        return item.apartmentId+"|"+item.buildingId;
      },
     //解绑网关
     gatewayUnbind(index,row){
        this.$confirm(this.$t('deviceList.confirmUnbindGateway'),this.$t("tenant.hint"), {
          confirmButtonText: this.$t("tenant.confirm"),
          cancelButtonText: this.$t("tenant.cancel"),
          type: 'warning'
        }).then(() => {
         
         var formData = new FormData();
         formData.append("deviceType",row.deviceType);
         formData.append("deviceId ", row.deviceId);
         formData.append("isForceUnbind",1);
         this.$server
          .exam("/customer/apartment/unbindDevice", formData)
          .then(data => {
           if (data.code == 200) {
             this.getGatewayPageList();
             this.$message({
               message: data.message,
               type: "success"
              });
           } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
        }).catch(() => {
          this.$message({
            type: 'info',
            message:this.$t('deviceList.cancleUnbind')
          });          
        });   
     } ,
    //添加网关  
    addGateway() {
      var formData = new FormData();
      formData.append("deviceName", this.gatewayForm.addGatewayName);
      formData.append("deviceId", this.gatewayForm.addGatewayNum);
      formData.append("deviceType",0);
      formData.append("roomId", this.gatewayForm.roomId);
      this.$server
        .exam("/customer/apartment/bindFirstDevice", formData)
        .then(data => {
          if (data.code == 200) {
            var rtnData = data["data"][0];
            this.addGatewayVisible = false;
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            var obj = {};
            obj.roomId=this.gatewayForm.roomId;
            // obj.apartmentId = this.infoData.apartmentId;
            obj.rId = rtnData.recordId;
            obj.loading = loading;
            obj.opType = "addGateway";
            obj.this=this;
            this.$store.dispatch("checkResult", obj); //等待回调
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
      //绑定网关设备
      onBindGateway(){
        this.addGatewayVisible=true;
      },
      //终端设备解绑
      deviceUnbind(index,row){
        this.$confirm(this.$t('deviceList.confirmUnbindLock'),this.$t("tenant.hint"), {
          confirmButtonText: this.$t("tenant.confirm"),
          cancelButtonText: this.$t("tenant.cancel"),
          type: 'warning'
        }).then(() => {
         var formData = new FormData();
         formData.append("deviceType",row.deviceType);
         formData.append("deviceId ", row.deviceId);
         formData.append("isForceUnbind",1);
         this.$server
          .exam("/customer/apartment/unbindDevice", formData)
          .then(data => {
           if (data.code == 200) {
             this.getLockPageList();
             this.$message({
               message: data.message,
               type: "success"
              });
           } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
        }).catch(() => {
          this.$message({
            type: 'info',
            message:this.$t('deviceList.cancleUnbind')
          });          
        });   
      },
      //选择网关楼层
      gatewayFloorSelectChange(val){
        this.gatewayForm.roomId="";
        this.gatewayForm.roomData=[];
        this.getRoomPageList(this.gatewayForm.apartmentId,val,0,"");
      },
      //选择网关公寓
      gatewayApartmentSelectChange(val){
         this.gatewayForm.floorId="";
         this.gatewayForm.roomId="";
         this.gatewayForm.roomData=[];
         this.gatewayForm.floorId=[];
         var apartmentId=val.split("|")[0];
         var buildingId=val.split("|")[1];
         this.gatewayForm.apartmentItem=val;
         this.gatewayForm.apartmentId=apartmentId;
         this.gatewayForm.buildingId=buildingId;
         this.getFloorPageList(apartmentId,buildingId,0);
         
      },
      
      //选择房间后加载网关列表
      deviceRoomSelectChange(val){
         this.getBindDeviceGatewayPageList(val);
      },

      deviceFloorSelectChange(val){
        this.bindDeviceForm.roomId="";
        this.bindDeviceForm.roomData=[];
        // this.getRoomPageList(this.bindDeviceForm.apartmentId,val,1,"");
      },
      //选择公寓值改变方法
      deviceApartmentSelectChange(val){
         this.bindDeviceForm.floorId="";
         this.bindDeviceForm.roomId="";
         this.bindDeviceForm.roomData=[];
         this.bindDeviceForm.floorId=[];
         var apartmentId=val.split("|")[0];
         var buildingId=val.split("|")[1];
         this.bindDeviceForm.apartmentItem=apartmentId+'|'+buildingId;
         this.bindDeviceForm.apartmentId=apartmentId;
         this.bindDeviceForm.buildingId=buildingId;
         this.getFloorPageList(apartmentId,buildingId,1);
      },
     

      //房间绑定门锁
       bindDeviceRoom() {
       var roomId=this.bindDeviceForm.roomId;
       var deviceId=this.bindDeviceForm.lockId;
       var deviceName=this.bindDeviceForm.lockName;
       var deviceType=this.bindDeviceForm.deviceType;
       if(roomId==""||roomId==null){
         this.$message({
            message:this.$t('deviceList.chooseRoom'),
            type: "warning"
         });
         return false;
       }
       if(deviceName==""||deviceName==null){
          this.$message({
            message:this.$t('deviceList.inputDeviceName'),
            type: "warning"
         });
          return false;
       }
      if(deviceType==1){
        //联网锁绑定
        var formData = new FormData();
        formData.append("firstDeviceId", this.bindDeviceForm.gatewayId);
        formData.append("firstDeviceType", 0);
        formData.append("roomId", this.bindDeviceForm.roomId);
        formData.append("secondDeviceId", this.bindDeviceForm.lockId);
        formData.append("secondDeviceName", deviceName);
        formData.append("secondDeviceType", 1);
        this.$server
        .exam("/customer/apartment/bindSecondDevice", formData)
        .then((data) => {
          if (data.code == 200) {
           
            if(data.data==""||data.data==null){
              this.$message({
               message: data.message,
               type: "warning",
              });
            }else{
             var rtnData = data["data"][0];
             this.addNetLockVisible = false;
             const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
             });
             var obj = {};
             obj.rId = rtnData.recordId;
             obj.loading = loading;
             obj.opType = "netLockBind";
             obj.othis = this;
             this.$store.dispatch("checkResult", obj);
            }
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
      }
      else if(deviceType==2){
        //离线锁绑定
        if( this.bindDeviceForm.lockNum==""|| this.bindDeviceForm.lockNum==null){
         this.$message({
            message:this.$t('deviceList.inputLockNum'),
            type: "warning"
         });
          return false;
        }
        const loading = this.$loading({
         lock: true,
         text: "Loading",
         spinner: "el-icon-loading",
         background: "rgba(0, 0, 0, 0.7)",
        });
        var formData = new FormData();
        formData.append("deviceName", deviceName);
        formData.append("lockPassword", this.bindDeviceForm.lockNum);
        formData.append("roomId", this.bindDeviceForm.roomId);
        this.$server
        .exam("/customer/apartment/bindOfflineLock", formData)
        .then((data) => {
          loading.close();
          if (data.code == 200) {
            this.bindDeviceVisible = false;
            this.getLockPageList();
            this.$message({
              message:data.message,
              type: "success",
            });
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
       }else{
        //直连锁绑定
        if(deviceId==""||deviceId==null){
         this.$message({
            message: this.$t('deviceList.inputDeviceNum'),
            type: "warning"
         });
          return false;
        }
        var formData = new FormData();
        formData.append("deviceId", this.bindDeviceForm.lockId);
        formData.append("deviceName", this.bindDeviceForm.lockName);
        formData.append("roomId", this.bindDeviceForm.roomId);
        formData.append("secondDeviceType", this.bindDeviceForm.deviceType);
        this.$server
         .exam("/customer/apartment/bindDevice", formData)
         .then((data) => {
          if (data.code == 200) {
            this.bindDeviceVisible=false;
            if(data.data==""||data.data==null){
              this.$message({
               message: data.message,
               type: "warning",
              });
            }else{
              this.$message({
               message: data.message,
               type: "success",
              });
              this.getLockPageList();
            // var rtnData = data["data"];
            // this.addNetLockVisible = false;
            // const loading = this.$loading({
            //   lock: true,
            //   text: "Loading",
            //   spinner: "el-icon-loading",
            //   background: "rgba(0, 0, 0, 0.7)",
            // });
            // var obj = {};
            // obj.apartmentId = this.$store.state.schoolId;
            // obj.rId = rtnData.recordId;
            // obj.loading = loading;
            // obj.opType = "addEndDevice";
            // obj.othis = this;
            // obj.deviceType = this.bindDeviceForm.deviceType;
            // this.$store.dispatch("checkResult", obj);
            }
           
          } else {
            this.$message({
              message: data.message,
              type: "warning",
            });
          }
        });
       }
    },
      //打开绑定终端设备
      bindDevice(){
        // this.bindDeviceForm.floorData="";
        // this.bindDeviceForm.roomData="";
        // this.bindDeviceForm.apartmentItem="";
        // this.bindDeviceForm.apartmentId="";
        // this.bindDeviceForm.buildingId="";
        // this.bindDeviceForm.floorId="";
        // this.bindDeviceForm.roomId="";
        // this.bindDeviceForm.gatewayData=[];
        // this.bindDeviceForm.gatewayId="";
        // this.bindDeviceForm.lockNum="";
        this.bindDeviceVisible=true;
      },
      //解绑
      handleUnbind(index,row){
       this.$confirm(this.$t('deviceList.confirmUnbindCollector'),this.$t("tenant.hint"), {
          confirmButtonText: this.$t("tenant.confirm"),
          cancelButtonText: this.$t("tenant.cancel"),
          type: 'warning'
        }).then(() => {
         var formData = new FormData();
         formData.append("deviceType",12);
         formData.append("deviceId ", row.deviceId);
         formData.append("isForceUnbind",1);
         this.$server
          .exam("/customer/apartment/unbindDevice", formData)
          .then(data => {
           if (data.code == 200) {
             this.getFgPageList();
             this.$message({
               message: data.message,
               type: "success"
              });
           } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('deviceList.cancleUnbind')
          });          
        });   
      },
      //提交选择公寓
      confirmChooseApartment(){
       if (this.currentApartmentRow == "" || this.currentApartmentRow == null) {
         this.$message({
          message: this.$t("tenant.chooseApartment"),
          type: "warning"
         });
         return false;
       }
       this.checkInVisible = true;
       this.apartmentListVisible = false;
       this.addDevice.apartmentName = this.currentApartmentRow.apartmentName;
       this.addDevice.apartmentId = this.currentApartmentRow.apartmentId;
      //  this.getApartmentBuilding(this.currentApartmentRow);//获取楼栋房间信息
      //  this.checkInForm.roomName="";
      },

      handleCurrentChangeDetail(val){
         console.log(JSON.stringify(val));
         this.currentApartmentRow = val;
      },

      onSelectApartment(){
        this.apartmentPower();
      },

      chooseApartment(){
        this.apartmentListVisible=true;
      },

      addFgDevice(){
          var formData = new FormData();
          // formData.append("apartmentId ",this.addDevice.apartmentId);
          formData.append("deviceId", this.addDevice.deviceId);
          formData.append("deviceName", this.addDevice.deviceName);
          formData.append("deviceType", 12);
          this.$server
          .exam("/customer/gateway/userBindDevice", formData)
          .then(data => {
           if(data.code == 200) {
            var rtnData = data["data"];
            const loading = this.$loading({
              lock: true,
              text: "绑定中...",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            var obj = {};
            obj.rId = rtnData.recordId;
            obj.loading = loading;
            obj.othis=this;
            obj.opType = "addFgDevice";
            this.$store.dispatch("checkResult", obj); //等待回调 
           } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
      },

      onBindFgDevice(){
        this.addDevice.apartmentId="";
        this.addDevice.apartmentName="";
        this.addDevice.deviceId="";
        this.addDevice.adviceName="";
        this.addDeviceFlag=true;
      },

      getBindDeviceGatewayPageList(roomId){
          var formData = new FormData();
          formData.append("roomId",roomId);
          this.$server
          .exam("/customer/apartment/getApartmentRoomUsableGateway", formData)
          .then(data => {
           if (data.code == 200) {
             console.log(JSON.stringify(data.data));
             this.bindDeviceForm.gatewayData=data.data;
            } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
       },
      
      //网关设备
      getGatewayPageList(){
          var formData = new FormData();
          if(this.deviceListForm.apartemtnName!=""&&this.deviceListForm.apartmentName!=null){
            formData.append("apartmentName",this.deviceListForm.apartmentName);
          }
          if(this.deviceListForm.deviceId!=""&&this.deviceListForm.deviceId!=null){
            formData.append("deviceId",this.deviceListForm.deviceId);
          }
          formData.append("deviceType",0);
          formData.append("pageNo", this.gatewayPageData.offset);
          formData.append("pageSize", this.gatewayPageData.pageNumber);
          this.$server
          .exam("/customer/gateway/listGateway", formData)
          .then(data => {
           if (data.code == 200) {
             this.gatewayPageData.gatewayData = data.data.records;
             this.gatewayPageData.total = data.data.total;
             
            } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
       },

        //指纹发卡机
        getFgPageList(){
          var formData = new FormData();
          formData.append("pageNo", this.fgPageData.offset);
          formData.append("pageSize", this.fgPageData.pageNumber);
          this.$server
          .exam("/customer/gateway/listCardMachine", formData)
          .then(data => {
           if (data.code == 200) {
             this.fgPageData.fgData = data.data.records;
             this.fgPageData.total = data.data.total;
            } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
       },
        //门锁设备
        getLockPageList(){
          var formData = new FormData();
          if(this.deviceListForm.apartemtnName!=""&&this.deviceListForm.apartmentName!=null){
            formData.append("apartmentName",this.deviceListForm.apartmentName);
          }
          if(this.deviceListForm.deviceId!=""&&this.deviceListForm.deviceId!=null){
            formData.append("deviceId",this.deviceListForm.deviceId);
          }
          if(this.deviceListForm.batteryLow!=""&&this.deviceListForm.batteryLow!=null){
            formData.append("batteryLow",this.deviceListForm.batteryLow);
          }
          if(this.deviceListForm.online!=""||this.deviceListForm.online!=null){
              formData.append("isOnline",this.deviceListForm.online);
          }
          // formData.append("deviceType",1);
          formData.append("pageNo", this.lockPageData.offset);
          formData.append("pageSize", this.lockPageData.pageNumber);
          this.$server
          .exam("/customer/lock/listLock", formData)
          .then(data => {
           if (data.code == 200) {
             this.lockPageData.lockData = data.data.records;
             this.lockPageData.total = data.data.total;
            } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
       },

    apartmentPower(type){
      var formData = new FormData();
      this.$server.exam("/customer/apartment/listOwnerApartment", formData).then(data => {
        if (data.code == 200) {
          this.apartmentList = data.data;
          //初始化绑定设备界面公寓列表
          this.gatewayForm.apartmentData = data.data;
          this.gatewayForm.apartmentItem=data.data[0].apartmentId+'|'+data.data[0].buildingId;
          this.gatewayForm.apartmentId=data.data[0].apartmentId;
          this.gatewayForm.buildingId=data.data[0].buildingId;
          this.getFloorPageList(data.data[0].apartmentId,data.data[0].buildingId,0);

          this.bindDeviceForm.apartmentData = data.data;
          this.bindDeviceForm.apartmentItem=data.data[0].apartmentId+'|'+data.data[0].buildingId;
          this.bindDeviceForm.apartmentId=data.data[0].apartmentId;
          this.bindDeviceForm.buildingId=data.data[0].buildingId;
          this.getFloorPageList(data.data[0].apartmentId,data.data[0].buildingId,1);
         
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },

    getFloorPageList(apartmentId,buildingId,type){
      var formData = new FormData();
      formData.append("apartmentId",apartmentId);
      formData.append("buildingId",buildingId);
      this.$server.exam("/customer/apartment/listBaseFloor", formData).then(data => {
        if (data.code == 200) {
          if(type==0){
            this.gatewayForm.floorData = data.data;
            this.gatewayForm.floorId=data.data[0].floorId;
            this.getRoomPageList(this.bindDeviceForm.apartmentId,data.data[0].floorId,0,"");
          }else{
             this.bindDeviceForm.floorData = data.data;
             this.bindDeviceForm.floorId=data.data[0].floorId;
             this.getRoomPageList(this.bindDeviceForm.apartmentId,data.data[0].floorId,1,"");
          }
           
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },

    getRoomPageList(apartmentId,floorId,type,val){
      var formData = new FormData();
      formData.append("apartmentId",apartmentId);
      formData.append("floorId",floorId);
      formData.append("bindDevice",0);//过滤未绑定门锁房间
      if(val!=""&&val!=null){
        formData.append("roomName",val); 
      }
      formData.append("pageNo", 1);
      formData.append("pageSize", 100);
      this.$server.exam("/customer/apartment/listRooms", formData).then(data => {
        if (data.code == 200) {
          if(type==0){
             this.gatewayForm.roomData = data.data.records;
          }else{
             this.bindDeviceForm.roomData = data.data.records;
          }
         
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },

     gHandleSizeChange(val) {
       this.gatewayPageData.pageNumber = val;
       this.getGatewayPageList();
     },
     gHandleCurrentChange(val) {
       this.gatewayPageData.offset = val;
       this.getGatewayPageList();
     },
     fHandleSizeChange(val) {
       this.fPageData.pageNumber = val;
       this.fPageList();
     },
     fHandleCurrentChange(val) {
       this.fPageData.offset = val;
       this.fPageList();
     },
     lHandleSizeChange(val) {
       this.lockPageData.pageNumber = val;
       this.getLockPageList();
     },
     lHandleCurrentChange(val) {
       this.lockPageData.offset = val;
       this.getLockPageList();
     },
    apartmentHandleSizeChange(val) {
      this.apartmentPageData.pageNumber = val;
      this.apartmentPower();
    },
    apartmentHandleCurrentChange(val) {
      this.apartmentPageData.offset = val;
      this.apartmentPower();
    }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/deviceManage/deviceList.vue